import { P2GBox } from '@parcel2go/core-ui';
import { P2GDate } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { CollectionDateApiModel } from '~/lib/api/smartsend/types';
import { SettingsCache } from '~/lib/consts/settings-cache';
import P2GContentDropDown from '../../P2GContentDropDown';
import ItemCollectionDateView from './ItemCollectionDateView';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  dates: CollectionDateApiModel[];
  selected?: Date;
  setDate: (d: Date) => void;
  variant?: 'body2';
  hideHeader: boolean;
  dateSize?: 'small' | 'medium' | 'large';
}

export default function ItemCollectionDate(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const selectedDate = useMemo(() => {
    if (!props.dates || props.dates.length === 0) {
      return null;
    }
    if (!SettingsCache.settings.Features.includes('CollectionDates')) {
      return null;
    }
    return new Date(props.selected || props.dates[0].Date);
  }, [props.selected, props.dates]);

  if (!selectedDate) {
    return null;
  }

  return (
    <>
      <P2GContentDropDown
        control={
          props.hideHeader ? (
            <P2GLink>
              <P2GDate variant={props.variant} date={selectedDate} size={props.dateSize} />
            </P2GLink>
          ) : (
            <P2GText variant={props.variant}>
              {t('COLLECTION_DATE_LABEL', { defaultValue: 'Collection:' })}{' '}
              <P2GLink>
                <P2GDate variant={props.variant} date={selectedDate} size={props.dateSize} />
              </P2GLink>
            </P2GText>
          )
        }
      >
        <P2GBox pt={1} pb={1}>
          <ItemCollectionDateView
            textAlign="left"
            limit={5}
            size="medium"
            dates={props.dates}
            selected={selectedDate}
            setDate={props.setDate}
          />
        </P2GBox>
      </P2GContentDropDown>
    </>
  );
}
